import { useState } from 'react';
import './SearchPanel.css';

const COUNTRIES = [
  { value: 'DEU', label: '🇩🇪 Deutschland' },
  { value: 'AUT', label: '🇦🇹 Österreich' },
  { value: 'CHE', label: '🇨🇭 Schweiz' },
  { value: '', label: '🌍 Alle EU' },
];

const PROCEDURES = [
  { value: '', label: 'Alle Verfahren' },
  { value: 'open', label: 'Offenes Verfahren' },
  { value: 'restricted', label: 'Nicht offenes Verfahren' },
  { value: 'negotiated', label: 'Verhandlungsverfahren' },
  { value: 'competitive-dialogue', label: 'Wettbewerblicher Dialog' },
];

export default function SearchPanel({ onSearch, loading }) {
  const today = new Date();
  const from = new Date(today); from.setDate(from.getDate() - 30);
  const to = new Date(today); to.setDate(to.getDate() + 90);

  const [params, setParams] = useState({
    keyword: '',
    country: 'DEU',
    procedure: '',
    dateFrom: from.toISOString().slice(0, 10),
    dateTo: to.toISOString().slice(0, 10),
    limit: 100,
  });

  const set = (k, v) => setParams(p => ({ ...p, [k]: v }));

  const handleSearch = () => {
    const query = buildQuery(params);
    onSearch({ ...params, query });
  };

  return (
    <aside className="search-panel">
      <div className="search-panel-inner">
        <div className="panel-title">
          <span>Suche</span>
          <span className="panel-subtitle">EU-Vergabedatenbank</span>
        </div>

        <div className="field-group">
          <div className="section-label">Stichwort</div>
          <input
            type="text"
            placeholder="z.B. Architektur, Planung…"
            value={params.keyword}
            onChange={e => set('keyword', e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSearch()}
          />
        </div>

        <div className="field-group">
          <div className="section-label">Land</div>
          <select value={params.country} onChange={e => set('country', e.target.value)}>
            {COUNTRIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
          </select>
        </div>

        <div className="field-group">
          <div className="section-label">Verfahrensart</div>
          <select value={params.procedure} onChange={e => set('procedure', e.target.value)}>
            {PROCEDURES.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
          </select>
        </div>

        <div className="field-group">
          <div className="section-label">Zeitraum</div>
          <div className="date-row">
            <div>
              <div className="date-label">Von</div>
              <input type="date" value={params.dateFrom} onChange={e => set('dateFrom', e.target.value)} />
            </div>
            <div>
              <div className="date-label">Bis</div>
              <input type="date" value={params.dateTo} onChange={e => set('dateTo', e.target.value)} />
            </div>
          </div>
        </div>

        <div className="field-group">
          <div className="section-label">Max. Treffer</div>
          <select value={params.limit} onChange={e => set('limit', Number(e.target.value))}>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
          </select>
        </div>

        <button className="btn btn-primary search-btn" onClick={handleSearch} disabled={loading}>
          <div className={`spinner ${loading ? 'active' : ''}`} />
          {loading ? 'Suche läuft…' : '🔍 Suche starten'}
        </button>

        <div className="cpv-info">
          <div className="section-label">CPV-Codes</div>
          <div className="cpv-tags">
            <span className="cpv-tag">71000000</span>
            <span className="cpv-tag active">71200000</span>
          </div>
          <div className="cpv-hint">Architektur- & Ingenieurleistungen</div>
        </div>
      </div>
    </aside>
  );
}

function buildQuery({ keyword, country, procedure, dateFrom, dateTo }) {
  const parts = ['(classification-cpv="71000000" OR classification-cpv="71200000")'];
  if (country) parts.push(`buyer-country="${country}"`);
  if (dateFrom) parts.push(`publication-date>=${dateFrom.replace(/-/g, '')}`);
  if (keyword) parts.push(keyword.replace(/['"]/g, ''));
  return parts.join(' AND ');
}
